import React, { useEffect, useMemo } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { getPathFromPageId } from 'helpers'
import { usePageInfo } from 'providers/PageInfoProvider'

import {
  selectCurrentVariantCohort,
  selectCurrentVariantSteps,
  selectLanguage,
} from 'root-redux/selects/common'
import { selectUUID } from 'root-redux/selects/user'

import { useBulkSelector } from 'hooks/common/useBulkSelector'

import { goTo } from 'browser-history'

const useSelectors = () =>
  useBulkSelector({
    steps: selectCurrentVariantSteps,
    cohort: selectCurrentVariantCohort,
    uuid: selectUUID,
    language: selectLanguage,
  })

export const SubscribeFlow: React.FC = () => {
  const { search, hash } = useLocation()
  const { cohort, uuid, language } = useSelectors()
  const { steps } = usePageInfo()

  const firstPagePath = useMemo(
    () =>
      getPathFromPageId({
        pageId: steps[0].id,
        cohort,
        uuid,
        language,
        currentSearch: search,
        hash,
      }),
    [cohort, language, steps, search, uuid, hash],
  )

  useEffect(() => {
    const URLParams = new URLSearchParams(search)
    const uuidFromUrl = URLParams.get('uuid')

    if (!uuidFromUrl) {
      goTo(firstPagePath)
    }
  }, [search, firstPagePath])

  return <Outlet />
}
